<script setup lang="ts">
const lp = useLocalePath()
const {
  public: {baseUrl},
} = useRuntimeConfig()

const {fetch} = useHome()

const {data: initialData} = await useAsyncData('home', () => fetch())
const {data: home} = useLivePreview({initialData: initialData.value, depth: 4})

if (!home.value) {
  throw createError({status: 503, message: 'Could not load the page.'})
}

const meta = home.value?.meta

useSeoMeta({
  title: meta?.title,
  description: meta?.description,
  ogUrl: baseUrl,
  ogTitle: meta?.ogTitle || meta?.title,
  ogDescription: meta?.ogDescription || meta?.description,
  ogImage: resolveMediaUrl(meta?.image),
  ogImageAlt: resolveMediaAlt(meta?.image),
})
</script>

<template>
  <main v-if="home" class="flex w-full flex-col overflow-hidden">
    <Hero v-if="home.hero" :data="home.hero" />

    <Team v-if="home.team" :data="home.team" />

    <Reviews v-if="home.reviews" :data="home.reviews" />

    <!-- <LazyIndustries v-if="home.industries" :data="home.industries" /> -->

    <LazyOurWork v-if="home.ourWork" :data="home.ourWork" />

    <LazyTechStack v-if="home.tech" :data="home.tech" />

    <LazyClients v-if="home.clients" :data="home.clients" />

    <LazyCta :href="lp('/contact')" :label="$t('home.contact.ctaLabel')" />

    <LazyFaq v-if="home.faq" :data="home.faq" />

    <Container class="h-32" />
  </main>
</template>
